module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00090-fs8.b3cc075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00090-fs8.png
// module id = 243
// module chunks = 0